import { text } from "./attachment.text";
export const createAttachmentNodeSpec = (filestackService) => ({
    group: "inline",
    inline: true,
    attrs: {
        file: {},
        url: { default: undefined },
    },
    toDOM: (node) => {
        var _a, _b, _c;
        const attrs = node.attrs;
        return [
            "a",
            {
                class: "attachment-link",
                href: filestackService.getAttachmentUrl(attrs),
                target: "_blank",
                rel: "noreferrer",
            },
            (_c = (_b = (_a = attrs.file) === null || _a === void 0 ? void 0 : _a.metadata) === null || _b === void 0 ? void 0 : _b.filename) !== null && _c !== void 0 ? _c : text.uploading,
        ];
    },
    parseDOM: [
        {
            tag: "a.attachment-link",
            priority: 60,
            getAttrs: (element) => {
                if (!element.href) {
                    return false;
                }
                return { url: element.href, file: {} };
            },
        },
    ],
});
export const createImageNodeSpec = (filestackService) => ({
    group: "block",
    selectable: false,
    draggable: false,
    attrs: {
        file: { default: {} },
        alignment: { default: "center" },
        size: {
            default: {
                width: 400,
            },
        },
        caption: { default: "" },
        url: { default: undefined },
    },
    toDOM: (node) => {
        const attrs = node.attrs;
        return [
            "figure",
            { class: "editor-image" },
            ["img", { src: filestackService.getImageUrl(attrs) }],
            ["figcaption", { class: "editor-image-caption" }, attrs.caption],
        ];
    },
    parseDOM: [
        {
            tag: "img[src]",
            getAttrs: (element) => {
                if (!element.src) {
                    return false;
                }
                return { url: element.src, file: {} };
            },
        },
    ],
});
export const createVideoNodeSpec = (filestackService) => ({
    group: "block",
    selectable: true,
    draggable: false,
    attrs: {
        alignment: {
            default: "left",
        },
        file: {},
        size: {
            default: {
                width: 400,
            },
        },
    },
    toDOM(node) {
        const attrs = node.attrs;
        return [
            "video",
            {
                controls: "",
                draggable: false,
                class: "editor-video",
                style: `max-width: ${attrs.size.width}px`,
            },
            [
                "source",
                {
                    src: filestackService.getVideoUrl(attrs),
                },
            ],
        ];
    },
    parseDOM: [
        {
            tag: "video",
            getAttrs: (element) => {
                if (!element.src) {
                    return false;
                }
                return {
                    file: {},
                    url: element.src,
                    size: {
                        width: 400,
                    },
                };
            },
        },
    ],
});
